import { Heading, Text } from "@chakra-ui/layout";
import React from "react";
import "../../App.css";

function Privacy() {
  return (
    <div style={{ padding: 40 }}>
      <Heading as="h1" mb={5}>
        AIO robot chef, Privacy policy
      </Heading>
      <Heading as="h2" size={"md"} mt={2} mb={2}>
        INTRODUCTION AND OVERVIEW
      </Heading>
      <Text>
        This Privacy Policy describes how AIO Robot Chef (“Company,” “we,”
        “our,” or “us”) collects, uses, and shares information about you as well
        as your rights and choices about such use and sharing, and applies to
        your use of any online service location that posts a link to this
        Privacy Policy and all features, content, and other services that we
        own, control, and make available through our game software and
        associated sites (collectively, the “Service”). This Privacy Policy does
        not apply to our information collection activities outside of the
        Service (unless otherwise stated below or at the time of collection). By
        using the Service, you agree to our Terms of Use and to our collection,
        use and disclosure practices, and other activities as described in this
        Privacy Policy. If you do not agree and consent, discontinue use of the
        Service. If you have any questions about our privacy practices, please
        contact us as set forth in the section entitled “Contact Us” below.
      </Text>
      <Heading as="h2" size={"md"} mt={2} mb={2}>
        INFORMATION COLLECTION
      </Heading>
      <Heading as="h3" size={"sm"} mt={2} mb={2}>
        INFORMATION YOU PROVIDE
      </Heading>
      <Text>We do not collect any personal information.</Text>
      <Heading as="h3" size={"sm"} mt={2} mb={2}>
        INFORMATION COLLECTED AUTOMATICALLY
      </Heading>
      <Text>
        We automatically collect information about your device and how your
        device interacts with our Service. We may use Service Providers to
        collect this information. Some examples of information we collect
        include the following:
      </Text>
      <Text>
        Service Use Data. We collect data about the features you use, the pages
        you visit, the e-mails and advertisements you view, the products you
        purchase, the time of day you browse, your referring and exiting pages,
        and other similar information. Device Connectivity and Configuration
        Data. We collect data about the type of device or browser you use, your
        device's operating software, your internet service provider, your
        device’s regional and language settings, and other similar information.
        This data also includes IP address, MAC address, device advertising Id
        (e.g., IDFA or AAID), and other device identifiers. Location Data. We
        collect data about your device's location, which can be precise (e.g.,
        latitude/longitude data) or imprecise (e.g., location derived from an IP
        address or data that indicates a city or postal code level). We use
        various current - and later - developed technologies to collect this
        information (“Tracking Technologies”), including the following:
      </Text>
      <Text>
        Log Files. A log file is a file that records events that occur in
        connection with your use of the Service, such as your service use data.
        Cookies. A cookie is a small data file stored on your device that acts
        as a unique tag to identify your browser. We use two types of cookies:
        session cookies and persistent cookies. Session cookies make it easier
        for you to navigate the Service and expire when you close your browser.
        Persistent cookies help with personalizing your experience, remembering
        your preferences, and supporting security features. Additionally,
        persistent cookies allow us to bring you advertising both on and off the
        Service. Persistent cookies may remain on your device for extended
        periods of time, and generally may be controlled through your browser
        settings. Pixels. A pixel (also known as a web beacon) is code embedded
        in a website, video, e-mail, or advertisements that sends information
        about your use to a server. There are various types of pixels, including
        image pixels (which are small graphic images) and JavaScript pixels
        (which contains JavaScript code). When you access a website, video,
        e-mail, or advertisement that contains a pixel, the pixel may permit us
        or a third party to drop or read cookies on your browser. Pixels are
        used in combination with cookies to track activity by a particular
        browser on a particular device. We may incorporate pixels from third
        parties that allow us track our conversions, bring you advertising both
        on and off the Service, and provide you with additional functionality,
        such as the ability to connect our Service with your social media
        account. Device Fingerprinting. Device fingerprinting is the process of
        analyzing and combining sets of information elements from your device’s
        browser, such as JavaScript objects and installed fonts, in order to
        create a “fingerprint” of your device and uniquely identify your device
        and apps. App Technologies. There are a variety of tracking technologies
        that may be included in our apps, and these are not browser-based like
        cookies and cannot be controlled by browser settings. For example, our
        apps may include third party SDKs, which is code that sends information
        about your use to a server, and is in effect the app version of a pixel.
        These SDKs allow us track our conversions, bring you advertising both on
        and off the Service, and provide you with additional functionality, such
        as the ability to connect our Service with your social media account.
        Some information about your use of the Service and certain Third Party
        Services (defined below) may be collected using Tracking Technologies
        across time and services and used by us and third parties for purposes
        such as to associate different devices you use, and deliver relevant ads
        and/or other content to you on the Service and certain Third Party
        Services.
      </Text>
      <Text>
        For further information on Tracking Technologies and your rights and
        choices regarding them, see the sections entitled “Third Parties” and
        “Your Rights and Choices” below.
      </Text>
      <Heading as="h3" size={"sm"} mt={2} mb={2}>
        INFORMATION FROM OTHER SOURCES
      </Heading>
      We may also obtain information about you from other third party sources.
      We protect data obtained from these third parties according to the
      practices described in this Privacy Policy, plus any additional
      restrictions imposed by the source of the data. These third party sources
      vary over time, but may include:
      <Text>
        Data brokers from which we purchase demographic data to supplement the
        data we collect. Social networks when you reference our Service or grant
        permission to Company to access your data on one or more of these
        services. Partners with which we offer co-branded services, sell or
        distribute our products, or engage in joint marketing activities. For
        further information on Third Party Services, see the section entitled
        “Third Parties” below.
      </Text>
      <Heading as="h2" size={"md"} mt={2} mb={2}>
        USE OF INFORMATION
      </Heading>
      We use information about you for our legitimate interests, including to:
      <ul>
        <li>
          Perform services requested by you, such as to respond to your
          comments, questions, and requests, and provide customer service.
        </li>
        <li>
          Send you technical notices, updates, security alerts, information
          regarding changes to our policies, and support and administrative
          messages.
        </li>
        <li>Monitor and analyze trends, usage, and activities.</li>
        <li>
          Improve the Service or other Company websites, apps, marketing
          efforts, products and services.
        </li>
      </ul>
      <Heading as="h2" size={"md"} mt={2} mb={2}>
        SHARING OF INFORMATION
      </Heading>
      We share information about you as follows:
      <Text>
        Service Providers. We may share your information with our agents,
        vendors, and other service providers (collectively “Service Providers”)
        in connection with their work on our behalf. Service Providers assist us
        with services such as payment processing, data analytics, marketing and
        promotional services, Promotions, website hosting, and technical
        support. Service Providers are prohibited from using your information
        for any purpose other than to provide this assistance, although we may
        permit them to use aggregate information which does not identify you or
        de-identified data for other purposes.
      </Text>
      <Text>
        Business Partners. We may share your information with our business
        partners in connection with offering you co-branded services, selling or
        distributing our products, or engaging in joint marketing activities.
        For example, we may share information about you with a retailer for
        purposes of providing you with product support.
      </Text>
      <Text>
        Third Parties. We may share your information with third parties for
        purposes of facilitating your requests (such as when you choose to share
        information with a social network about your activities on the Service)
        and in connection with tailoring advertisements, measuring and improving
        our Service and advertising effectiveness, and enabling other
        enhancements.
      </Text>
      <Heading as="h2" size={"md"} mt={2} mb={2}>
        PUBLIC INFORMATION
      </Heading>
      Certain areas of the Service, such as user profiles, are designed to help
      you share information with the world. If you make information public
      through our Service, other people will have access to it. Please think
      carefully before making information public as you are solely responsible
      for any information you make public. Once you have posted information, you
      may not be able to edit or delete such information; however, California
      residents and European data subjects have additional rights as set forth
      in “Your Rights and Choices” below.
      <Heading as="h2" size={"md"} mt={2} mb={2}>
        THIRD PARTIES
      </Heading>
      <Heading as="h3" size={"sm"} mt={2} mb={2}>
        THIRD PARTY SERVICES
      </Heading>
      Our Service contains content from and hyperlinks to websites, locations,
      platforms, and services operated and owned by third parties (“Third Party
      Services”). These Third Party Services may use Tracking Technologies to
      independently collect information about you and may solicit information
      from you. The information collected and stored by third parties, whether
      through our Service, a Third Party Service, a Third Party Feature (defined
      below), or a third party device, remains subject to their own policies and
      practices, including what information they share with us, your rights and
      choices on their services and devices, and whether they store information
      in the U.S. or elsewhere. We encourage you to familiarize yourself with
      and consult their privacy policies and terms of use.
      <Heading as="h3" size={"sm"} mt={2} mb={2}>
        THIRD PARTY FEATURES
      </Heading>
      We may allow you to connect our Service to a Third Party Service or offer
      our Service through a Third Party Service (“Third Party Features”). If you
      use a Third Party Feature, both we and the applicable third party may have
      access to and use information associated with your use of the Third Party
      Feature, and you should carefully review the third party’s privacy policy
      and terms of use. Some examples of Third Party Features include the
      following:
      <Text>
        Liking, Sharing, and Logging-In. We may embed a pixel or SDK on our
        Service that allows you to “like” or “share” content on, or log-in to
        your Company account through, Third Party Services, including social
        networks such as Facebook and Twitter. If you choose to engage with such
        a Third Party Service through our Service, we may collect any
        information you have authorized the Third Party Service to share with us
        (such as your user ID, billing information, public profile information,
        e-mail address, birthday, friends list, and other account and profile
        data). Likewise, if you choose to engage with such a Third Party Service
        through our Service or visit our Service while logged in to that Third
        Party Service on your device, the Third Party Service may receive
        information about your activities on our Service and be able to
        associate that information with information the Third Party Service
        already has about you.
      </Text>
      <Text>
        Brand Pages and Chatbots. We may offer our content on social networks
        such as a Facebook and Twitter. Any information you provide to us when
        you engage with our content (such as through our brand page or via our
        chatbot on Facebook Messenger) is treated in accordance with this
        Privacy Policy. Also, if you publicly reference our Service on a Third
        Party Service (e.g., by using a hashtag associated with Company in a
        tweet or post), we may use your reference on or in connection with our
        Service.
      </Text>
      <Heading as="h3" size={"sm"} mt={2} mb={2}>
        ANALYTICS AND INTEREST-BASED ADVERTISING
      </Heading>
      <Text>
        Our Service contains Tracking Technologies owned and operated by Third
        Parties. For example, we use Tracking Technologies from third party
        analytics provides, such as Google Analytics, to help us analyze your
        use of the Service, compile statistic reports on the Service’s activity,
        and provide us with other services relating to Service activity and
        internet usage. We also work with ad serving services, advertisers, and
        other third parties to serve advertisements on the Service and/or on
        Third Party Services. These third parties may use Tracking Technologies
        on our Service and Third Party Services (including in e-mails and
        advertisements) to track your activities across time and services for
        purposes of associating the different devices you use, and delivering
        relevant ads and/or other content to you on the Service and Third Party
        Services or third party devices after you have left the Service
        (“Interest-based Advertising”).
      </Text>
      <Text>
        We may serve ads on Third Party Services, such as Facebook and Google,
        that are targeted to reach people (or similar people) on those services
        that have visited our Service or that are also identified in one of more
        of our databases (“Matched Ads”). This is done by matching common
        factors between our data and the data of Third Party Services. If we use
        Facebook Custom Audiences to serve Matched Ads on Facebook services, you
        should be able to hover over the box in the right corner of such a
        Facebook ad and find out how to opt-out. We are not responsible for such
        Third Party Services’ failure to comply with your opt-out instructions.
      </Text>
      <Text>
        For further information on Tracking Technologies and your rights and
        choices regarding them, please see the sections entitled “Information
        Collected Automatically” above and “Your Rights and Choices” below.
      </Text>
      <Heading as="h2" size={"md"} mt={2} mb={2}>
        YOUR RIGHTS AND CHOICES
      </Heading>
      <Heading as="h3" size={"sm"} mt={2} mb={2}>
        REVIEW AND UPDATE OF ACCOUNT INFORMATION
      </Heading>
      You may access, update, or remove certain account information that you
      have voluntarily submitted to us through the Service by sending an e-mail
      to the e-mail address set forth in the section entitled “Contact Us”
      below. We may require additional information from you to allow us to
      confirm your identity. Please note that we will retain and use your
      information as necessary to comply with our legal obligations, resolve
      disputes, and enforce our agreements. California residents and European
      data subjects have additional rights as set forth in the sections entitled
      “Your California Privacy Rights” and “Your European Privacy Rights” below.
      <Heading as="h3" size={"sm"} mt={2} mb={2}>
        TRACKING TECHNOLOGY CHOICES
      </Heading>
      <Text>
        Cookies and Pixels. Most browsers accept cookies by default. You can
        instruct your browser, by changing its settings, to decline or delete
        cookies. If you use multiple browsers on your device, you will need to
        instruct each browser separately. Your ability to limit cookies is
        subject to your browser settings and limitations.
      </Text>
      <Text>
        App Technologies. You can reset your device advertising Id at any time
        through your device settings, which is designed to allow you to limit
        the use of information collected about you. For information on how to do
        this on Apple devices, visit Apple.com or
        https://support.apple.com/en-us/HT202074. For information on how to do
        this on Android devices, visit Google.com. You can stop all collection
        of information via an app by uninstalling the app.
      </Text>
      <Text>
        Location-Identifying Technologies. The location data collected through
        an app depends on your device settings and app permissions. You can
        exercise choice over the location data collected through our apps by (i)
        for GPS data, disabling location in your device settings or disabling
        location permissions to that app; (ii) for Bluetooth data, disabling
        Bluetooth and any Bluetooth scanning option in your device settings; or
        (iii) for WiFi data, disabling WiFi and any WiFi scanning option in your
        device settings. You can stop collection of all location data via an app
        by uninstalling the app.
      </Text>
      <Text>
        Do Not Track. Your browser settings may allow you to automatically
        transmit a “Do Not Track” signal to online services you visit. Note,
        however, there is no industry consensus as to what site and app
        operators should do with regard to these signals. Accordingly, we do not
        monitor or take action with respect to “Do Not Track” signals or other
        mechanisms. For more information on “Do Not Track,” visit
        http://www.allaboutdnt.com.
      </Text>
      <Text>
        Please be aware that if you disable or remove Tracking Technologies some
        parts of the Service may not function correctly.
      </Text>
      <Heading as="h3" size={"sm"} mt={2} mb={2}>
        ANALYTICS AND INTEREST-BASED ADVERTISING
      </Heading>
      <Text>
        You can opt-out of your data being used by Google Analytics through
        cookies by visiting https://tools.google.com/dlpage/gaoptout and
        downloading the Google Analytics Opt-out Browser Add-on.
      </Text>
      <Text>
        Some of the third parties that collect information from or about you on
        the Service in order to provide more relevant advertising to you
        participate in the Digital Advertising Alliance (“DAA”) Self-Regulatory
        Program for Online Behavioral Advertising. This program offers a
        centralized location where users can make choices about the use of their
        information for online behavioral advertising. To learn more about the
        DAA and your opt-out options for their members, please visit (i) for
        website opt-out, http://www.aboutads.info/choices; and (ii) for mobile
        app opt-out, http://www.aboutads.info/appchoices. In addition, some of
        these third parties may be members of the Network Advertising Initiative
        (“NAI“). To learn more about the NAI and your opt-out options for their
        members, please visit http://www.networkadvertising.org/choices/. Please
        note that if you opt-out of online behavioral advertising using any of
        these methods, the opt-out will only apply to the specific browser or
        device from which you opt-out. Further, opting-out only means that the
        selected members should no longer deliver certain Interest-based
        Advertising to you, but does not mean you will no longer receive any
        targeted content and/or ads (e.g., from other ad networks). We are not
        responsible for effectiveness of, or compliance with, any third-parties’
        opt-out options or programs or the accuracy of their statements
        regarding their programs.
      </Text>
      <Text>
        You may also limit our use of information collected from or about your
        mobile device for purposes of serving online behavioral advertising to
        you by going to your device settings and selecting “Limit Ad Tracking”
        (for iOS devices) or “Opt out of Interest-Based Ads” (for Android
        devices).
      </Text>
      <Text>
        E-mails. You can opt-out of receiving promotional e-mails from us at any
        time by following the instructions as provided in e-mails to click on
        the unsubscribe link, or e-mailing us at the e-mail address set forth in
        the section entitled “Contact Us” below with the word UNSUBSCRIBE in the
        subject field of the e-mail. Please note that you cannot opt-out of
        non-promotional e-mails, such as those about your account, transactions,
        servicing, or Company’s ongoing business relations.
      </Text>
      <Text>
        Push Notifications. If you have opted-in to receive push notification on
        your device, you can opt-out at any time by adjusting the permissions in
        your device or uninstalling our app.
      </Text>
      <Text>
        Text Messages and Calls. You can opt-out of receiving text messages or
        calls to your phone number at any time by (i) for text messages, texting
        “STOP” in response to any text message you receive from us or contacting
        us as set forth in the section entitled “Contact Us” below and
        specifying you want to opt-out of text messages; and (ii) for calls,
        requesting opt-out during any call you receive from us or contacting us
        as set forth in the section entitled “Contact Us” below and specifying
        you want to opt-out of calls. Please note that your opt-out is limited
        to the e-mail address, device, and phone number used and will not affect
        subsequent subscriptions.
      </Text>
      <Heading as="h3" size={"sm"} mt={2} mb={2}>
        DATA SECURITY
      </Heading>
      We implement and maintain reasonable administrative, physical, and
      technical security safeguards to help protect your information from loss,
      theft, misuse and unauthorized access, disclosure, alteration and
      destruction. Nevertheless, transmission via the internet is not completely
      secure and we cannot guarantee the security of your information.
      <Heading as="h2" size={"md"} mt={2} mb={2}>
        CHANGES TO THIS PRIVACY POLICY
      </Heading>
      We reserve the right to revise and reissue this Privacy Policy at any
      time. Any changes will be effective immediately upon posting of the
      revised Privacy Policy. Your continued use of our Service indicates your
      consent to the Privacy Policy then posted. If the changes are material, we
      may provide you additional notice to your e-mail address.
      <Heading as="h2" size={"md"} mt={2} mb={2}>
        CONTACT US
      </Heading>
      If you have any questions or comments about this Privacy Policy, our data
      practices, or our compliance with applicable law, please contact us:
      <Text>By e-mail: marina.v.goldburt@gmail.com</Text>
    </div>
  );
}

export default Privacy;
